module.exports = __webpack_public_path__ + "media/images/text_message_welcome-01b9f0fcffc21f3b09fea2cb246ba658.svg";